/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_Q4Inputs */

const en_to_typescript_faq_q4 = /** @type {(inputs: To_Typescript_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What about arrays with mixed types?`)
};

const ko_to_typescript_faq_q4 = /** @type {(inputs: To_Typescript_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`혼합 타입 배열은 어떻게 처리되나요?`)
};

const ja_to_typescript_faq_q4 = /** @type {(inputs: To_Typescript_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`型が混在する配列はどうなりますか？`)
};

/**
* | output |
* | --- |
* | "What about arrays with mixed types?" |
*
* @param {To_Typescript_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_q4 = /** @type {((inputs?: To_Typescript_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_q4(inputs)
	if (locale === "ko") return ko_to_typescript_faq_q4(inputs)
	return ja_to_typescript_faq_q4(inputs)
});